module.exports = __webpack_public_path__ + "img/foxdown_slider_1.5b8fb46f.png";